import { createFileRoute } from '@tanstack/react-router';

import { CallNowScreen } from '@/features/portal-helpline/components/CallNowScreen';

export const Route = createFileRoute('/client/call-now')({
  component: CallNowRoute,
  staticData: { crumb: 'Call now' },
});

function CallNowRoute() {
  return <CallNowScreen />;
}
